import { default as classNames, default as cn } from "classnames";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import Modal from "../../components/Modal";
import TableComponent from "../../components/TableComponent";
import { DEFAULT_DECK_AVATAR } from "../../constants/images";
import { fetchAllTexts } from "../../app/catalog/catalog.slice";
import { deleteTexts } from "../../api/texts.service";
import styles from "./Texts.module.sass";

/** Map catalog text item to the shape expected by the table (supports both catalog and legacy getTexts shape). */
function toTableItem(c) {
  const id = c?.sourceId ?? c?._id;
  const lastUpdate = c?.lastUpdate ?? c?.updatedAt;
  const titleStr = typeof c?.title === "string" ? c.title : c?.title?.find((x) => x?.lang === "en")?.trans;
  const descStr = typeof c?.description === "string" ? c.description : c?.description?.find((x) => x?.lang === "en")?.trans;
  const words = c?.contentCount ?? c?.analysis?.words;
  const active = c?.active;
  const level = c?.level;
  return {
    _id: id,
    lastUpdate,
    active,
    titleStr,
    descStr,
    words,
    level,
    raw: c,
  };
}

    const navigation = ["All", "Active", "Draft"]

    const columns = [
        {
            header: 'Last update',
            accessor: 'date'
        },
        {
            header: 'Status',
            accessor: 'type'
        },
        {
            header: 'Detail',
            accessor: 'detail'
        },
        {
            header: 'Words',
            accessor: 'delivered'
        },
        {
            header: 'Level',
            accessor: 'read'
        },
        {
            header: 'Actions',
            accessor: 'actions'
        },
    ]

    const Texts = () => {
        const { t } = useTranslation();
        const history = useHistory();
        const dispatch = useDispatch();
        const allTexts = useSelector((state) => state.catalog?.allTexts ?? []);

        const [activeTab] = useState(navigation[0]);
        const [selectedItem, setSelectedItem] = useState(null);
        const [isVisibleModalDelete, setisVisibleModalDelete] = useState(false);

        const dataTable = allTexts?.length
            ? allTexts.map((c) => {
                    const item = toTableItem(c);
                    return {
                        date: {
                            data: "data",
                            dataComponent: (
                                <div>
                                    <div style={{ fontWeight: "bold", color: "inherit" }}>
                                        {dayjs(item.lastUpdate).format("DD MMM YYYY")}
                                    </div>
                                    <div>{dayjs(item.lastUpdate).format("HH:mm[h]")}</div>
                                </div>
                            ),
                        },
                        type: {
                            data: item.active,
                            dataComponent: (
                                <div className={cn(item.active ? "status-green-dark" : "status-red-dark", styles.status)}>
                                    {item.active ? "Active" : "Draft"}
                                </div>
                            ),
                        },
                        detail: {
                            data: "detail",
                            dataComponent: (
                                <div>
                                    <div style={{ fontWeight: "bold", color: "inherit" }}>{item.titleStr}</div>
                                    <p style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: 200 }}>
                                        {item.descStr}
                                    </p>
                                </div>
                            ),
                        },
                        delivered: { data: item.words, dataComponent: item.words },
                        read: { data: item.level, dataComponent: item.level },
                        actions: {
                            data: "actions",
                            dataComponent: (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <button style={{ color: "blue" }} onClick={() => history.push(`/texts/content/${item._id}`)}>
                                        View Content
                                    </button>
                                    <button style={{ color: "blue", marginLeft: 20 }} onClick={() => history.push(`/texts/edit/${item._id}`)}>
                                        Edit
                                    </button>
                                    <button
                                        style={{ color: "red", marginLeft: 20 }}
                                        onClick={() => {
                                            setSelectedItem(item.raw);
                                            setisVisibleModalDelete(true);
                                        }}
                                    >
                                        Delete
                                    </button>
                                </div>
                            ),
                        },
                    };
                })
            : [];

        useEffect(() => {
            dispatch(fetchAllTexts());
        }, [dispatch]);

        const handleDelete = async () => {
            const id = selectedItem?.sourceId ?? selectedItem?._id;
            if (!id) {
                setSelectedItem(null);
                setisVisibleModalDelete(false);
                return;
            }
            const response = await deleteTexts({ _id: id });
            if (response?.status === 200 || response?.data) {
                toast.success(t("toast.deletedSuccessfully"));
                dispatch(fetchAllTexts());
            }
            setSelectedItem(null);
            setisVisibleModalDelete(false);
        };

        return (
            <div>
                <Modal
                    visible={isVisibleModalDelete}
                    onClose={() => {
                        setSelectedItem(null);
                        setisVisibleModalDelete(false);
                    }}
                >
                    <div style={{ margin: "48px 6px", width: "100%", fontSize: 16 }}>Are you sure you want to delete the text? ({typeof selectedItem?.title === "string" ? selectedItem.title : selectedItem?.title?.find((x) => x?.lang === "en")?.trans})</div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        className={cn("button-stroke button-small", styles.button)}
                        style={{ marginRight: 10 }}
                        onClick={() => {
                            setSelectedItem(null);
                            setisVisibleModalDelete(false);
                        }}
                    >
                        <span>Cancel</span>
                    </button>
                    <button className={cn("button-stroke-red button-small", styles.button)} onClick={handleDelete}>
                        <span>Delete</span>
                    </button>
                    </div>
                </Modal>
                {
                    /*
                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: 30}} className={cn(styles.nav, "tablet-hide")}>
                    {navigation.map((x, index) => (
                        <button
                            className={cn(styles.link, {
                            [styles.active]: x === activeTab,
                            })}
                            onClick={() => setActiveTab(x)}
                            key={index}
                        >
                            {x}
                        </button>
                    ))}
                </div>
                     */
                }

                {/* Carousel: textos nuevos (isNewContent) o primeros de catalog.allTexts */}
                {allTexts?.length > 0 && (() => {
                    const forCarousel = allTexts.filter((t) => t?.isNewContent).length > 0
                        ? allTexts.filter((t) => t?.isNewContent).slice(0, 12)
                        : allTexts.slice(0, 12);
                    return forCarousel.length > 0 ? (
                    <div className={styles.inlineScroll} style={{ marginBottom: 20 }}>
                        {forCarousel.map((text, i) => {
                            const id = text?.sourceId ?? text?._id;
                            const title = typeof text?.title === "string" ? text.title : text?.title?.find((x) => x?.lang === "en")?.trans;
                            const words = text?.contentCount ?? text?.analysis?.words;
                            return (
                                <div key={id || i} className={styles.deckWrapperWW}>
                                    <div style={{ cursor: "pointer" }} onClick={() => history.push(`/texts/edit/${id}`)} className={styles.imgWrapperWW}>
                                        <img
                                            src={text?.imageUrl ? (text.imageUrl.includes("undefined") ? DEFAULT_DECK_AVATAR : text.imageUrl) : DEFAULT_DECK_AVATAR}
                                            className={styles.imgObjectFit}
                                            alt="Logo"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = DEFAULT_DECK_AVATAR;
                                            }}
                                        />
                                    </div>
                                    <div className={styles.deckInfoWW}>
                                        <div style={{ fontSize: "14px" }} className={styles.truncatemultiline}>
                                            {title || "Untitled"}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "gray" }}>{words ?? 0}</div>
                                    </div>
                                    {text?.premium && (
                                        <div className={styles.deckPremiumWW}>
                                            <div className={classNames("status-green", styles.status)}>Premium</div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    ) : null;
                })()}




                <TableComponent
                    title={activeTab}
                    columns={columns}
                    data={activeTab === 'All' ? dataTable : dataTable?.filter(c => c?.type?.data === activeTab)}
                    isSearch={false}
                    isFilter
                    isButton
                    buttonText={"New Text"}
                    buttonIcon={<BiPlus />}
                    buttonHandler={()=>history.push('/texts/add')}
                />
            </div>
        );
    }

    export default Texts;